/**
 * i18n setup.
 *
 * - Romanian is the default (primary market)
 * - English is the fallback (international users)
 * - Language persisted in localStorage (`sms_hub_lang`)
 * - Detection order: localStorage → navigator
 *
 * To switch language at runtime: `i18n.changeLanguage('en')`.
 * To use in components: `const { t } = useTranslation()` and `t('auth.login.title')`.
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ro from "./i18n/ro.json";
import en from "./i18n/en.json";

export const SUPPORTED_LANGUAGES = ["ro", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { translation: ro },
      en: { translation: en },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "sms_hub_lang",
      caches: ["localStorage"],
    },
    // Dev-only: show missing keys in console
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (lngs, _ns, key) => {
          // eslint-disable-next-line no-console
          console.warn(`[i18n] Missing key "${key}" for`, lngs);
        }
      : undefined,
  });

export default i18n;
